<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card id="billdata" v-if="guia != null">
          <v-card-text>
            <v-row dense>
              <v-col class="d-flex justify-center align-center">
                <div class="text-h6">Master : {{ guia.guia_master }}</div>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <img src="images/logo.jpg" width="200" height="43" />
              </v-col>
              <v-col class="d-flex justify-end align-center">
                <barcode
                  v-bind:value="guia != null ? guia.guia_hija : ''"
                  v-bind:height="25"
                >
                  Error al generar barcode
                </barcode>
              </v-col>
            </v-row>
            <br />
            <v-divider></v-divider>
            <v-row dense>
              <v-col>
                <div class="text-h5"><strong>Sender</strong></div>
                <v-divider></v-divider>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>Shipper :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.shipper }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>Remitente :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.remitente }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>Dirección :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">
                      {{ guia.direccion_remitente }}
                    </div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>Ciudad :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.ciudad_origen }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>País :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.shipper }}</div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <div class="text-h5"><strong>Receiver</strong></div>
                <v-divider></v-divider>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption">
                      <strong>Destinatario :</strong>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.destinatario }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>Cédula :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.cedula }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>Dirección :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.direccion }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>Provincia :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.provincia }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>Ciudad :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.ciudad }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption">
                      <strong>Cod Postal :</strong>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.cod_postal }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>Teléfono :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.telefono }}</div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <br />
            <v-divider></v-divider>
            <v-row dense>
              <v-col>
                <v-row dense>
                  <v-col><div class="text-h5"><strong>Envío</strong></div></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>No Articulos :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.no_articulos }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption"><strong>Valor :</strong></div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">${{ guia.valor }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Bultos :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.bultos }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption"><strong>ETA :</strong></div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.eta }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption"><strong>ETD :</strong></div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.etd }}</div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Descripción :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.descripcion }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption"><strong>Peso :</strong></div>
                      </v-col>
                      <v-col>
                        <div>{{ guia.peso_kg }} KG</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>No Vuelo :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.no_vuelo }}</div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <br />
            <v-divider></v-divider>
            <v-row dense>
              <v-col>
                <div class="text-h5"><strong>POD</strong></div>
                <v-divider></v-divider>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption">
                      <strong>Entregado a :</strong>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.pod_nombre }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>DNI :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.pod_dni }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>Fecha :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.pod_fecha }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>Hora :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.pod_hora }}</div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <div class="text-h5"><strong>Referencias</strong></div>
                <v-divider></v-divider>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption"><strong>Estatus :</strong></div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">
                      {{ guia.estatus != null ? guia.estatus.descripcion : "" }}
                    </div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption">
                      <strong>Referencia 1 :</strong>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.referencia1 }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption">
                      <strong>Referencia 2 :</strong>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.referencia2 }}</div>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <div class="text-caption">
                      <strong>Referencia 3 :</strong>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="text-caption">{{ guia.referencia3 }}</div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <br />
            <v-divider></v-divider>
            <v-row dense>
              <v-col>
                <v-row dense>
                  <v-col
                    ><div class="text-h5"><strong>Información adicional</strong></div></v-col
                  >
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Operador :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.operador }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption"><strong>Depot :</strong></div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.depot }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Guía agente :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.guia_agente }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Agente :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">
                          {{ guia.agente != null ? guia.agente.nombre : "" }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Tiempo transito :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">
                          {{ guia.tiempo_transito }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Fecha liberación :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">
                          {{ guia.fecha_liberacion }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Proceso :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">
                          {{
                            guia.proceso != null
                              ? guia.proceso === 0
                                ? "Normal"
                                : "Con Novedad"
                              : ""
                          }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>No controlado :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">
                          {{
                            guia.no_controlado != null
                              ? guia.no_controlado == 0
                                ? "No"
                                : "Si"
                              : ""
                          }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Observación :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.observacion }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Fecha Est. Vuelo :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.fecha_estimada_vuelo }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Novedad Vuelo :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.novedad_vuelo }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Fecha Declaración :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.fecha_declaracion }}</div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Tipo Aforo :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.tipo_aforo }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Refrendo :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.refrendo }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>MRN :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.mrn }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>MSN :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.msn }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>HSN :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.hsn }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Valor Declarado :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">${{ guia.valor_declarado }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Peso Ingresado Aduana :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.peso_ingresado_aduana }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Categoria :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.categoria }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Causa Abandono :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.causa_abandono }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Estatus Aduana :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.estatus_aduana }}</div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="4">
                        <div class="text-caption">
                          <strong>Novedad Inexpress :</strong>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="text-caption">{{ guia.novedad_inexpress }}</div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <br />
            <v-divider></v-divider>
            <v-row dense>
              <v-col>
                <v-row dense>
                  <v-col>
                    <v-col><div class="text-h5"><strong>Historial</strong></div></v-col>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row dense>
                  <v-col>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>Estatus</th>
                          <th>Fecha</th>
                          <th>Hora</th>
                          <th>Comentarios</th>
                          <th>Digitador</th>
                          <th>Creación</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(st, index) in guia.estatuslist"
                          :key="index"
                        >
                          <td class="text-caption">
                            {{
                              st.estatus != undefined
                                ? st.estatus.descripcion
                                : ""
                            }}
                          </td>
                          <td class="text-caption">
                            {{ formatDate(st.fecha + "T00:00:00") }}
                          </td>
                          <td class="text-caption">{{ st.hora }}</td>
                          <td class="text-caption">{{ st.comentarios }}</td>
                          <td class="text-caption">
                            {{ st.usuario != null ? st.usuario.name : "" }}
                          </td>
                          <td class="text-caption">
                            {{ formatDate(st.created_at) }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row dense>
              <v-col>
                <v-row dense>
                  <v-col>
                    <v-col><div class="text-h5"><strong>Historial Agente</strong></div></v-col>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row dense v-if="guia != null && guia.id_agente == 4">
                  <v-col>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>Ciudad</th>
                          <th>Descripcion</th>
                          <th>Estado</th>
                          <th>Fecha/Hora</th>
                          <th>Transporte</th>
                          <th>Transportista</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(dt, index) in datosTrackingTra"
                          :key="index"
                        >
                          <td class="text-caption">
                            {{dt.ciudad}}
                          </td>
                          <td class="text-caption">
                            {{dt.descripcion}}
                          </td>
                          <td class="text-caption">{{dt.estado}}</td>
                          <td class="text-caption">{{dt.fechaHora}}</td>
                          <td class="text-caption">
                            {{dt.transporte}}
                          </td>
                          <td class="text-caption">
                            {{dt.transportista}}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <v-row dense v-if="guia != null && guia.id_agente == 11">
                  <v-col>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>Ciudad</th>
                          <th>Descripcion</th>
                          <th>Fecha/Hora</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(dt, index) in datosTrackingServ"
                          :key="index"
                        >
                          <td class="text-caption">
                            {{dt.OriMov}}
                          </td>
                          <td class="text-caption">
                            {{dt.DesMov}}
                          </td>
                          <td class="text-caption">{{dt.FecMov}}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="text-right">
          <v-spacer></v-spacer
          ><v-btn color="blue" dark @click="imprimirGuia()">Imprimir <v-icon>mdi-printer</v-icon></v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueBarcode from "vue-barcode";
//import { Printd } from 'printd'
import apicon from "../plugins/apicon";
import utils from "../utils/utils";
import apiServiEntrega from "../plugins/apiServiEntrega";

export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    barcode: VueBarcode,
  },
  data() {
    return {
      guia: null,
      datosTrackingTra: [],
      datosTrackingServ: [],
    };
  },
  methods: {
    getData: async function () {
      if (this.id > 0) {
        await apicon
          .getDataApi(apicon.getApiBaseUrl() + "compraslinea/" + this.id)
          .then((result) => {
            this.guia = result;
          });
      }
    },
    consultarTrackingTramaco:async function(){
        await apicon.getDataApi(apicon.getApiBaseUrl() + "rastrearguiatramaco/" + this.guia.guia_agente).then((result) => {
          this.datosTrackingTra = result.lstSalidaTrackGuiaWs;
        });
      },
    formatDate: function (date) {
      return utils.formatDate(date);
    },
    imprimirGuia: function () {
      var mywindow = window.open("", "tracking div", "height=800,width=1000");
      const prtHtml = document.getElementById("billdata").innerHTML;
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      mywindow.document.write(
        `<!DOCTYPE html>
                <html>
                <head>
                    ${stylesHtml}
                </head>
                <body onload="window.print()">
                    ${prtHtml}
                </body>
                </html>`
      );
      //mywindow.document.write($("#billdata").html());
      //mywindow.document.write("</body></html>");
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10
      setTimeout(function () {
        mywindow.close();
      }, 1000);
      //const d = new Printd();
      //d.print(this.$el)
    },
  consultarTrackingServE:async function(){
     let datosServ = await apiServiEntrega.getTracking(this.guia.guia_agente)
     this.datosTrackingServ = datosServ.ConsultarGuiaImagenResult.Mov.InformacionMov;
     console.log(this.datosTrackingServ)
  }
  },
  mounted: async function () {
    await apicon.setAuthHeaders();
    await this.getData();
    await this.consultarTrackingTramaco();
    await this.consultarTrackingServE();
  },
};
</script>
